import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "user-preferences",
  class: "d-flex flex-fill list-page"
}
const _hoisted_2 = { class: "card background-fb no-border padding-lrb-8" }
const _hoisted_3 = { class: "loader-div-40" }
const _hoisted_4 = ["src"]

import {
  computed,
  defineAsyncComponent,
  onBeforeUnmount,
  onMounted,
  ref,
} from "vue";
import { ElButton, ElTable, ElTableColumn, ElTooltip } from "element-plus";
import { cloneDeep } from "lodash-es";
import { TYPE } from "vue-toastification";
import i18n from "@/core/i18n/i18n";
import { authInfo, updatePreferences } from "@/core/auth";
import { showAlert } from "@/core/popup";
import { ASSETS_BASE_URL, DEFAULT_LOGO } from "@/core/logo";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserPreferences',
  setup(__props) {

const { t } = i18n.global;

const InputSelector = defineAsyncComponent(
  () => import("@/user-preferences/components/InputSelector.vue")
);

const preferences = ref(cloneDeep(authInfo.value.preferences));

const shortCutPressed = ref(false);

const responseLoading = ref(false);

const tableData = computed(() =>
  preferences.value ? convertObjToList(preferences.value) : []
);

async function savePreferences() {
  responseLoading.value = true;
  const response = await updatePreferences(preferences.value);
  if (response) {
    showAlert(TYPE.SUCCESS, t("Preferences.PreferenceUpdated"));
  }
  responseLoading.value = false;
}

function updateData(key, value) {
  if (preferences.value[key].value !== value) {
    preferences.value[key].value = value;
    savePreferences();
  }
}

function saveShortCut(event) {
  if (!(event.keyCode === 83 && (event.ctrlKey || event.metaKey))) {
    return;
  }
  event.preventDefault();
  if (!shortCutPressed.value && !responseLoading.value) {
    shortCutPressed.value = true;
    savePreferences();
  }
}

function convertObjToList(obj) {
  const list = [];
  Object.entries(obj).forEach((entry) => {
    const [key, value] = entry;
    if (typeof value === "object") {
      list.push({
        key,
        value: cloneDeep(value),
      });
    }
  });
  return list;
}

function resetAllPreferences() {
  tableData.value.forEach((data) => {
    resetPreference(data.key, data.value, false);
  });
  savePreferences();
}

function resetPreference(key, preference, save) {
  if (preference.value !== preference.default) {
    preferences.value[key].value = preference.default;
    if (save) {
      savePreferences();
    }
  }
}

onMounted(() => {
  window.addEventListener("keydown", saveShortCut);
  window.addEventListener("keyup", () => {
    shortCutPressed.value = false;
  });
});

onBeforeUnmount(() => {
  window.removeEventListener("keydown", saveShortCut);
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(ElTable), {
          class: "oneTeg-table oneTeg-table--sm",
          data: tableData.value,
          height: "100%"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElTableColumn), {
              label: `${_unref(t)('Preferences.Preference')} ${_unref(t)('Common.Name')}`,
              prop: "value",
              width: "auto"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_unref(t)(scope.row.value.label)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(ElTableColumn), {
              label: _unref(t)('Common.Description'),
              width: "auto"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_unref(t)(scope.row.value.description)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(ElTableColumn), {
              label: _unref(t)('Common.Value'),
              width: "auto"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_unref(InputSelector), {
                  "key-val": scope.row.key,
                  class: "margin-top-10 margin-bottom-10",
                  preference: scope.row.value,
                  onUpdateData: updateData
                }, null, 8, ["key-val", "preference"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(ElTableColumn), { width: "100px" }, {
              header: _withCtx(() => [
                _createVNode(_unref(ElTooltip), {
                  placement: "left",
                  content: _unref(t)('Common.ReturnAllToDefault')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElButton), {
                      class: "btn-oneTeg",
                      size: "mini",
                      id: "reset-all-preferences",
                      onClick: resetAllPreferences
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "undo" })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["content"])
              ]),
              default: _withCtx((scope) => [
                _createVNode(_unref(ElTooltip), {
                  placement: "left",
                  content: _unref(t)('Common.ReturnToDefault')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElButton), {
                      class: "btn-oneTeg",
                      size: "mini",
                      id: `reset-${scope.row.key}-preference`,
                      onClick: ($event: any) => (resetPreference(scope.row.key, scope.row.value, true))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "undo" })
                      ]),
                      _: 2
                    }, 1032, ["id", "onClick"])
                  ]),
                  _: 2
                }, 1032, ["content"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
        alt: "Loading...",
        class: "loader-logo-40"
      }, null, 8, _hoisted_4)
    ], 512), [
      [_vShow, responseLoading.value]
    ])
  ], 64))
}
}

})